import styled from 'styled-components';

export const StyledFlex = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  flex-direction: row;
  .btn-add-new {
    margin-left: auto;
  }
`;
